/**
 * @module app.hl7
 */

import { autoinject, transient } from 'aurelia-framework';
import { Api } from 'app/shared/lib/api/api';
import { IQueryLoadOptions, IApiQueryResults, IApiSettingsResults } from 'app/shared/lib/api/api-types';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { Toaster } from 'app/shared/lib/toaster';
import { ApiQuery } from 'app/shared/lib/essette-api';
import * as HL7 from 'app/hl7/models/essette-api';

@transient()
@autoinject()
export class MessageService {

    ////****************** Functions ************************************************////
    constructor(
        private readonly api: Api,
        private readonly env: EnvironmentService,
        private readonly logger: AppLogger,
        private readonly toaster: Toaster) {

        this.logger.source = this;
    }

    public async get<T>(query: ApiQuery): Promise<IApiQueryResults<T>> {
        return await this.api.get(query) as IApiQueryResults<T>;
    }


    ////****************** Settings *************************************************////


    ////****************** Queries **************************************************////
    public async loadMessagesByMember(memberId: string, options?: Partial<IQueryLoadOptions>, includes: string[] = [], fields: string[] = []): Promise<IApiQueryResults<HL7.Message>> {
        const query = this.api
            .query('HL7/messages/')
            .filterIdentifier('member.id', memberId)
            .applyStandardLoadOptions(options)
            .include(...includes)
            .field(...fields);

        return await this.api.get(query);
    }

    ////****************** Loads ****************************************************////


    ////****************** Actions **************************************************////

}

